/**
 * Environment detection utilities
 * Distinguishes between development, staging, and production
 */

/**
 * Check if we're in development mode (running vite dev server)
 */
export const isDevelopment = (): boolean => {
  return import.meta.env.DEV === true;
};

/**
 * Check if we're in staging environment
 * Detected by checking if API URL contains "staging"
 */
export const isStaging = (): boolean => {
  const apiUrl = import.meta.env.VITE_API_URL || '';
  return apiUrl.toLowerCase().includes('staging');
};

/**
 * Check if we should show verbose logs
 * Shows logs in development AND staging, but hides them in production
 */
export const shouldLogVerbose = (): boolean => {
  return isDevelopment() || isStaging();
};

/**
 * Get current environment name
 */
export const getEnvironment = (): 'development' | 'staging' | 'production' => {
  if (isDevelopment()) {
    return 'development';
  }
  if (isStaging()) {
    return 'staging';
  }
  return 'production';
};

